module.exports = __webpack_public_path__ + "img/app_purchase@3x.f4103583.png";